<p-table [value]="ageGroups$ | async"
         [lazy]="true"
         class="admin-table">

  <ng-template pTemplate="emptymessage" let-columns>
    <div>{{ 'WS_DIRECTORY.TABLE_EMPTY' | translate }}</div>
  </ng-template>

  <ng-template pTemplate="caption">
    <div class="ui-g">
      <div class="ui-g-12">
        <button *gsShowIfHasPermission="['NDP_ORGANIZATION_AGE_GROUP_CREATE']"
                pButton class="ui-button-success fright"
                label="{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.ADD' | translate }}"
                (click)="create()"></button>
      </div>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.AGE_GROUP' | translate }}</th>
      <th>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.AGE_RANGE' | translate }}</th>
      <th>{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.GROUP_TYPE' | translate }}</th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template let-ageGroup pTemplate="body">
    <tr>
      <td>
        {{ ageGroup.ageGroupName }}
      </td>
      <td>
        <span
          *ngIf="ageGroup.startingAge && ageGroup.endingAge">{{ ageGroup.startingAge + '-' + ageGroup.endingAge }}</span>
      </td>
      <td>
        {{ ageGroup.groupType }}
      </td>
      <td class="action-column">
        <i class="fa fa-trash delete-appointment fright"
           *gsShowIfHasPermission="['NDP_ORGANIZATION_AGE_GROUP_UPDATE']"
           (click)="delete(ageGroup)"
           pTooltip="{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.DELETE_TOOLTIP' | translate }}"></i>
        <i class="fa fa-pen edit-appointment fright"
           *gsShowIfHasPermission="['NDP_ORGANIZATION_AGE_GROUP_UPDATE']"
           (click)="modify(ageGroup)"
           pTooltip="{{ 'DATA_PORTAL.ADMINISTRATION.AGE_GROUPS.MODIFY_TOOLTIP' | translate }}"></i>
      </td>
    </tr>
  </ng-template>
</p-table>

<wsd-add-age-range (onSave)="onSave($event)"></wsd-add-age-range>

<wsd-global-messages [life]="4000"></wsd-global-messages>

